export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-04.fe306e78.jpg";